import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'

import { EffectCoverflow, Navigation } from 'swiper/modules'
import ArrowForward from '@public/static/icons/advantageous/ArrowForward'
import ArrowBackward from '@public/static/icons/advantageous/ArrowBackward'
import UserIcon from '@public/static/icons/notifications/UserIcon'
import { useTranslation } from 'react-i18next'

type Props = {}

const Testimonials = ({}: Props) => {
  const { t } = useTranslation('advantageous')

  const data = [
    {
      image: '/static/images/authors/olivia.jpg',
      name: t('testimonials.testimonial5.name'),
      course: t('testimonials.testimonial5.course'),
      message: t('testimonials.testimonial5.message'),
    },
    {
      image:
        'https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/male/512/2.jpg',
      name: t('testimonials.testimonial6.name'),
      course: t('testimonials.testimonial6.course'),
      message: t('testimonials.testimonial6.message'),
    },
    {
      image:
        'https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/male/512/4.jpg',
      name: t('testimonials.testimonial7.name'),
      course: t('testimonials.testimonial7.course'),
      message: t('testimonials.testimonial7.message'),
    },
    {
      image:
        'https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/female/512/72.jpg',
      name: t('testimonials.testimonial1.name'),
      course: t('testimonials.testimonial1.course'),
      message: t('testimonials.testimonial1.message'),
    },
    {
      image:
        'https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/male/512/35.jpg',
      name: t('testimonials.testimonial2.name'),
      course: t('testimonials.testimonial2.course'),
      message: t('testimonials.testimonial2.message'),
    },
    {
      image:
        'https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/male/512/37.jpg',
      name: t('testimonials.testimonial3.name'),
      course: t('testimonials.testimonial3.course'),
      message: t('testimonials.testimonial3.message'),
    },
    {
      image:
        'https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/male/512/90.jpg',
      name: t('testimonials.testimonial4.name'),
      course: t('testimonials.testimonial4.course'),
      message: t('testimonials.testimonial4.message'),
    },
  ]

  const colors = [
    'linear-gradient(98.85deg, #FCF1FF 7.48%, #E4E7FF 100.01%)',
    'linear-gradient(98.85deg, #E4E7FF 7.48%, #FCF1FF 100.01%)',
    'linear-gradient(98.85deg, #FCF1FF 7.48%, #E4E7FF 100.01%)',
    'linear-gradient(98.85deg, #E4E7FF 7.48%, #FCF1FF 100.01%)',
    'linear-gradient(98.85deg, #FCF1FF 7.48%, #E4E7FF 100.01%)',
    'linear-gradient(98.85deg, #FCF1FF 7.48%, #E4E7FF 100.01%)',
    'linear-gradient(98.85deg, #E4E7FF 7.48%, #FCF1FF 100.01%)',
  ]

  return (
    <Container>
      <Wrapper>
        <Swiper
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          loop={true}
          breakpoints={{
            1024: {
              slidesPerView: 1.4,
              spaceBetween: 54,
            },
            0: {
              slidesPerView: 1.1,
              spaceBetween: 8,
            },
          }}
          pagination={false}
          modules={[EffectCoverflow, Navigation]}
          className="mySwiper !w-full"
          navigation={{
            enabled: true,
            nextEl: '.next-btn',
            prevEl: '.prev-btn',
          }}
        >
          {data.map((item, index) => (
            <SwiperSlide key={item.message} className="w-full rounded-[45px]">
              <Item style={{ background: colors[index % data.length] }}>
                <ItemWrapper>
                  <ItemCourse>{item.course}</ItemCourse>
                  <ItemMessage>“{item.message}”</ItemMessage>
                  <ItemUser>
                    {item.image ? (
                      <Image
                        src={item.image}
                        width={120}
                        height={120}
                        className="w-[40px] h-[40px] object-cover rounded-full shadow-sm"
                        alt={item.name}
                      />
                    ) : (
                      <div className="w-[40px] h-[40px] rounded-full flex bg-white items-center justify-center pt-2 overflow-hidden">
                        <UserIcon width={'100%'} height={'100%'} />
                      </div>
                    )}
                    <div className="flex flex-col gap-2">
                      <ItemUserName>{item.name}</ItemUserName>
                      <ItemUserBadge>
                        {t('testimonials.edugram500Author')}
                      </ItemUserBadge>
                    </div>
                  </ItemUser>
                </ItemWrapper>
              </Item>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className="absolute top-0 left-0 h-full lg:w-[20%] md:w-[15%] sm:w-[8%] w-[0%] bg-gradient-to-r from-white to-transparent z-[51]"></div>
        <div className="absolute top-0 right-0 h-full lg:w-[20%] md:w-[15%] sm:w-[8%] w-[0%] bg-gradient-to-r to-white from-transparent z-[51]"></div> */}
        <button
          aria-label="Next Slide"
          className="next-btn flex absolute lg:right-[18%] bg-white right-[calc(50%-62px)] sm:right-2 w-14 h-14 justify-center items-center rounded-full shadow-md -bottom-7 sm:bottom-[auto] sm:top-1/2 sm:-translate-y-1/2 z-[8]"
        >
          <ArrowForward width="14px" height="19px" />
        </button>
        <button
          aria-label="Previous Slide"
          className="prev-btn flex absolute bg-white w-14 h-14 justify-center items-center rounded-full shadow-md lg:left-[18%] left-[calc(50%-62px)] sm:left-2 -bottom-7 sm:bottom-[auto] sm:top-1/2 sm:-translate-y-1/2 z-[8]"
        >
          <ArrowBackward width="14px" height="19px" />
        </button>
      </Wrapper>
    </Container>
  )
}

export default Testimonials

const Container = styled.div`
  margin: 5rem 0px;
  overflow: visible;
`
const Wrapper = styled.div`
  display: flex;
  gap: 5rem;
  overflow: visible;
  position: relative;
  @media screen and (max-width: 568px) {
    gap: 2rem;
  }
`
const Item = styled.div`
  /* background-color: #c3caff; */
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9rem 4rem;
  height: 100%;
  @media screen and (max-width: 768px) {
    min-width: 100%;
  }
  @media screen and (max-width: 596px) {
    padding: 5rem 2.7rem;
  }
`
const ItemWrapper = styled.div`
  max-width: 701px;
  display: flex;
  gap: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const ItemCourse = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 18px;
  font-weight: 400;
  line-height: 33px;
  letter-spacing: 0.05em;
  text-align: center;
  text-decoration: underline;
  @media screen and (max-width: 596px) {
    font-size: 16px;
    line-height: 33px;
  }
`
const ItemMessage = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  color: ${colors.uguPurple};
  font-weight: 600;
  letter-spacing: 0.05em;
  text-align: center;
  font-size: 30px;
  line-height: 40px;
  @media screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 33px;
  }
  @media screen and (max-width: 596px) {
    font-size: 20px;
    line-height: 22px;
  }
`
const ItemUser = styled.div`
  display: flex;
  align-items: start;
  gap: 1rem;
`
const ItemUserName = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  @media screen and (max-width: 596px) {
    font-size: 14px;
    line-height: 14px;
  }
`
const ItemUserBadge = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  @media screen and (max-width: 596px) {
    font-size: 14px;
    line-height: 14px;
  }
`
